
import { Formik, Form, Field, ErrorMessage } from "formik";
import { sendEmail } from "../API/ApiService";

export default function ContactComponent() {

    function validate(values) {
        const errors = {}
        if (!values.email.includes("@")) {
            errors.email = "Enter a valid email."
        }
        if (values.message.length < 10) {
            errors.message = "Message must be at least 10 characters."
        }
        if (values.subject.length < 3) {
            errors.subject = "Subject must be at least 3 characters."
        }
        return errors;
    }

    function onSubmit(values, {resetForm}) {

        const userContact = {email: values.email, message: values.message, subject: values.subject}

        if (values.company) {
            console.log("Values.company = true")
            return;
        }
        sendEmail(userContact)
        resetForm()

    }

    return (
        <div className="contactouter">
            <div className="contactheader">Contact me:</div>
            <Formik
                initialValues={{email: "", subject: "", message: ""}}
                validate={validate}
                onSubmit={onSubmit}
                validateOnBlur={false}
                validateOnChange={false}>

            { () => (
                <Form className="contactinner">
                                   
                <div className="emailcontact">
                    <label>Your email address: </label><br/>
                    <Field className="contactinput" data-dashlane-disabled-on-field="true" data-form-type="other"
                    name="email" type="email"
                    placeholder="you@example.com"
                    style={{width:'100%', boxSizing: 'border-box'}}
                    ></Field>
                    <ErrorMessage name="email" component="div" />
                </div>
                <div className="subjectcontact">
                    <label>Subject: </label><br/>
                    <Field className="contactinput"
                    name="subject" type="text"
                    minLength={3}
                    data-dashlane-disabled-on-field="true"
                    style={{width:'100%', boxSizing: 'border-box'}}
                    ></Field>
                    <ErrorMessage name="subject" component="div" />
                </div>
                <div className="messagecontact">
                    <label>Message: </label><br/>
                    <Field className="mbox"
                    name="message" as="textarea"
                    minLength={10}
                    data-dashlane-disabled-on-field="true"
                    style={{width:'100%', boxSizing: 'border-box'}}
                    ></Field>
                    <ErrorMessage name="message" component="div" />

                </div><Field type="text" name="company" autoComplete="off" style={{display: 'none'}}></Field>

                <div className="submitcontact">
                    <button type="submit" className="submitbutton">Submit</button>
                </div>
            
                </Form> ) }
            </Formik>

        </div>
    )
}